"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.UNCLOSED_VARIABLE_REGEX = exports.MULTILINE_VARIABLE_REGEX = exports.MUSTACHE_REGEX = exports.VARIABLE_REGEX = void 0;
exports.getIsCharOrUnderscore = getIsCharOrUnderscore;
exports.isValidVariableName = isValidVariableName;
exports.extractVariables = extractVariables;
exports.stringifyValue = stringifyValue;
function getIsCharOrUnderscore(value) {
    const charOrUnderscore = /^[\p{L}\p{N}_]+$/u;
    return charOrUnderscore.test(value);
}
// Regex for valid variable names (unicode letters, underscores, starting with letter)
exports.VARIABLE_REGEX = /^\p{L}[\p{L}\p{N}_]*$/u;
// Regex to find variables in mustache syntax. Extra surrounding braces are
// treated as literals by SDK/compiler behavior, e.g. {{{name}}} -> {value}.
exports.MUSTACHE_REGEX = /{{([^{}]*)}}/g;
// Regex to find multiline variables
exports.MULTILINE_VARIABLE_REGEX = /{{[^{}]*\n[^{}]*}}/g;
// Regex to find unclosed variables
exports.UNCLOSED_VARIABLE_REGEX = /{{(?!{)(?![^{]*}})/g;
function isValidVariableName(variable) {
    return exports.VARIABLE_REGEX.test(variable);
}
function extractVariables(mustacheString) {
    const matches = Array.from(mustacheString.matchAll(exports.MUSTACHE_REGEX))
        .map((match) => match[1])
        .filter(isValidVariableName);
    return [...new Set(matches)];
}
function stringifyValue(value) {
    switch (typeof value) {
        case "string":
            return value;
        case "number":
            return value.toString();
        case "boolean":
            return value.toString();
        default:
            return JSON.stringify(value);
    }
}
